<template>
  <div class="flex items-center">
    <p
      class="text-inherit"
    >{{ maskedString }}</p
    >
  </div>
</template>

<script>
export default {
  name: "CellRendererPassword",
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
    maskedString() {
      return this.params.value ? this.params.value.replace(/./ig, '*') : "********";
    }
  }
};
</script>
